import { postData } from '../api-client';
import { ADD_FEEDBACK, FEED } from '../../shared/constants/routing-constants';


export function postFeedback(jsonData: any) {
  return postData(`${FEED}/${ADD_FEEDBACK}`, jsonData);
}